var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { PureComponent } from 'react';
import { LazyLoadImage, LazyLoadComponent, } from 'react-lazy-load-image-component';
import parse from 'url-parse';
import { BLANK_IMAGE_URL, BLANK_NO_USER_IMAGE_URL, UPLOADING_IMAGE_URL, } from '../../../define/consts/assets';
import { isSupportObjectFit } from '../../../define/polyfill';
import { makeBgImage } from '../../../helpers/common';
import { propAny, propBool, propOneOf, propStr, } from '../../../helpers/custom-prop-types';
import { fileLoad, fixRotate } from '../../../helpers/files';
import NoImage from './NoImage';
import SvgImage from './SvgImage';
const disabledContextMenu = (e) => e.preventDefault();
class Image extends PureComponent {
    constructor(props) {
        super(props);
        this.loadImage = (props) => {
            ;
            (() => __awaiter(this, void 0, void 0, function* () {
                let { src } = props;
                if (src instanceof File) {
                    src = yield fileLoad(src);
                    src = yield fixRotate(src);
                }
                if (!this.unmounted) {
                    this.setState({ src });
                }
            }))();
        };
        this.getShowSrc = () => {
            const { noImageType, src: propSrc } = this.props;
            const { src: stateSrc } = this.state;
            const isFile = propSrc instanceof File;
            if (isFile) {
                return stateSrc;
            }
            if (stateSrc) {
                return stateSrc;
            }
            if (noImageType === 'user') {
                return BLANK_NO_USER_IMAGE_URL;
            }
            return BLANK_IMAGE_URL;
        };
        this.getImageClass = (props) => {
            const { className, isBlur, isDisabledGrayScale, isGrayScale, isObjectFit, isObjectFitContain, } = props;
            return clsx(className, {
                'image-filter': isBlur || (isGrayScale && !isDisabledGrayScale),
                'is-blur': isBlur,
                'is-grayscale': isGrayScale && !isDisabledGrayScale,
                'is-object-fit': isObjectFit,
                'is-object-fit-contain': isObjectFitContain,
            });
        };
        this.onError = (e) => {
            const { noImageType } = this.props;
            e.target.src =
                noImageType === 'user' ? BLANK_NO_USER_IMAGE_URL : BLANK_IMAGE_URL;
        };
        const { src: propSrc } = props;
        const isFile = propSrc instanceof File;
        this.state = {
            src: isFile ? undefined : propSrc,
        };
        this.unmounted = false;
    }
    componentDidMount() {
        this.loadImage(this.props);
    }
    componentDidUpdate(prevProps) {
        const { src: prevSrc } = prevProps;
        const { src: nextSrc } = this.props;
        if (prevSrc !== nextSrc) {
            let shouldLoad;
            if (typeof prevSrc === 'undefined' ||
                prevSrc instanceof File ||
                nextSrc instanceof File) {
                // 初回読み込み、もしくはファイルが選択されていた場合は常に再ロードを行う
                shouldLoad = true;
            }
            else {
                // パス比較で異なる画像か確認する（S3の署名付きURLのデータを引き直した際、同一の画像であっても再ロードが走ってしまうため）
                const prevParsed = parse(prevSrc);
                const nextParsed = parse(nextSrc);
                shouldLoad =
                    `${prevParsed.hostname}${prevParsed.pathname}` !==
                        `${nextParsed.hostname}${nextParsed.pathname}`;
            }
            if (shouldLoad) {
                this.loadImage(this.props);
            }
        }
    }
    componentWillUnmount() {
        this.unmounted = true;
    }
    render() {
        const { allowContextMenu, alt, className, isBackground, isBlur, isDisabledGrayScale, isGrayScale, isObjectFit, isObjectFitContain, useImage: rawUseImage, } = this.props;
        const src = this.getShowSrc();
        const imageClass = this.getImageClass(this.props);
        const useImage = isSupportObjectFit && rawUseImage;
        if (src === undefined) {
            return null;
        }
        // 指定されたデータが存在しない場合
        if ([BLANK_IMAGE_URL, BLANK_NO_USER_IMAGE_URL, UPLOADING_IMAGE_URL].includes(src)) {
            return (_jsx(NoImage, { className: className, imageClass: imageClass, isBlur: isBlur, src: src, useImage: useImage }));
        }
        if (!useImage) {
            // filter効果ありで表示したい
            if (isBlur || isGrayScale) {
                return (_jsx(SvgImage, { className: className, isBlur: isBlur, isDisabledGrayScale: isDisabledGrayScale, isGrayScale: isGrayScale, isObjectFit: isObjectFit, isObjectFitContain: isObjectFitContain, src: src }));
            }
            // 背景画像として表示したい
            if (isBackground ||
                ((isObjectFit || isObjectFitContain) && !isSupportObjectFit)) {
                return (_jsx(LazyLoadComponent, { children: _jsx("div", { className: clsx(className, {
                            'is-object-fit-contain-polyfill': isObjectFitContain,
                            'is-object-fit-polyfill': isObjectFit,
                        }), style: makeBgImage(src) }) }));
            }
        }
        return (_jsx(LazyLoadImage, { alt: alt, className: imageClass, onContextMenu: allowContextMenu ? null : disabledContextMenu, onError: this.onError, src: src }));
    }
}
Image.propTypes = {
    allowContextMenu: propBool(),
    alt: propStr().isRequired,
    className: propStr(),
    isBackground: propBool(),
    isBlur: propBool(),
    isDisabledGrayScale: propBool(),
    isGrayScale: propBool(),
    isObjectFit: propBool(),
    isObjectFitContain: propBool(),
    noImageType: propOneOf(['default', 'user']),
    src: propAny(),
    useImage: propBool(),
};
Image.defaultProps = {
    allowContextMenu: true,
    className: '',
    isBackground: false,
    isBlur: false,
    isDisabledGrayScale: false,
    isGrayScale: false,
    isObjectFit: false,
    isObjectFitContain: false,
    noImageType: 'default',
    src: null,
    useImage: false,
};
export default Image;
